
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import Roles from "@/entities/Roles";
import GET_PROJECT from "@/apollo/projects/GetProject.gql";
import ProjectHeader from "@/components/projects/ProjectHeaderResources.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import UserIcon from "@/components/icons/UserIcon.vue";
import PageHeadIcon from "@/components/page/PageHeadIconNew.vue";
import TabsWithRoutes from "@/components/common/TabsWithRoutesNew.vue";
import ProjectDocumentsSideBar from "@/components/contractors/ProjectDocumentsSideBar.vue";
import TabNotificationBubble from "@/components/common/TabNotificationBubbleNew.vue";
import { Project, Company, User } from "@/generated/graphql";
import NavGrayArrow from "@/components/icons//NavGrayArrow.vue";
import RouteNames from "@/entities/RouteNames";
import RouteTabs from "@/entities/RouteTabs";

@Component({
  components: {
    ProjectHeader,
    TabsWithRoutes,
    LoadingOverlay,
    NavGrayArrow,
    ProjectDocumentsSideBar,
    TabNotificationBubble,
    PageHeadIcon,
    UserIcon,
  },
  apollo: {
    project: {
      query: GET_PROJECT,
      variables() {
        return this.projectFilter;
      },
      update: (data) => data.project_by_pk,
    },
  },
})
export default class ContractorProject extends mixins() {
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: Object, required: true }) readonly company!: Company;

  project?: Project = undefined;
  routes: typeof RouteNames = RouteNames;

  @Watch("project")
  changesInProjectForBreadCrumb() {
    let breadcrumbdoc;
    breadcrumbdoc =
      document.querySelector(
        ".project_details_in_contractor_li .crumb_item_content"
      ) ||
      document.querySelector(
        ".project_details_in_contractor_li.crumb_last_item > span"
      );

    if (breadcrumbdoc) {
      breadcrumbdoc.innerHTML = this.project.client_name;
    }

    // 	let parentElement = document.querySelector('.router-link-exact-active');

    // 	if (parentElement) {
    // 			parentElement.setAttribute('href', '/clients/contractors/');
    // }
  }

  get routeTabs(): RouteTabs {
    return {
      [RouteNames.CONTRACTOR_PROJECT_ACTIVITY]: `tasks (${this.activitiesCount})`,
      [RouteNames.CONTRACTOR_PROJECT_DETAILS]: "details",
      [RouteNames.CONTRACTOR_PROJECT_CLIENT_PROFILE]: `client-profile`,
      [RouteNames.CONTRACTOR_PROJECT_CARE_PLAN]: `care plan`,
      [RouteNames.CONTRACTOR_PROJECT_DOCUMENTS]: `documents (${this.documentsCount})`,
    };
  }

  get activitiesCount(): number {
    return this.project?.project_activities_aggregate.aggregate?.count || 0;
  }

  get projectPageRoute() {
    return {
      name: RouteNames.CONTRACTOR_PROJECTS,
    };
  }
  get projectFilter() {
    return {
      id: this.$route.params.id,
      uploadedById: this.currentUser.id,
      projectActivitiesWhere: {
        _and: [
          { deleted: { _eq: false } },
          { drafted: { _eq: false } },
          {
            contractor: {
              user: {
                id: {
                  _eq: this.currentUser.id,
                },
              },
            },
          },
        ],
      },
    };
  }
  get dashboardRoute() {
    return {
      name: RouteNames.DASHBOARD,
    };
  }
handleViewAllClick(): void {
    this.$nextTick(() => {
      const el = document.getElementById('content-scroll-manager');
      el.scrollTo({
        top: el.scrollHeight,
        behavior: 'smooth'
      });
    });
 
  }
  get isAdmin(): boolean {
    return this.currentUser.role === Roles.ADMIN;
  }

  get documentsCount(): number {
    return this.project?.project_documents_aggregate.aggregate?.count || 0;
  }

  get companyName(): string {
    return this.project?.company?.business_name || "-";
  }
}
